import React, { useState } from 'react';
import { safeText } from '../../utils/sanitize';

function formatDate(d) {
  try {
    const date = new Date(d);
    return date.toLocaleString();
  } catch {
    return '';
  }
}

export default function CommentItem({
  comment,
  isTopLiked,
  currentUser,
  liked,
  onLike,
  onDelete,
  onReply,
  onDeleteReply,
  onRequireAuth,
}) {
  const [replyOpen, setReplyOpen] = useState(false);
  const [replyText, setReplyText] = useState('');
  const [busy, setBusy] = useState(false);

  const canDelete = currentUser && (
    currentUser.role === 'admin' || currentUser.id === String(comment.user)
  );

  const submitReply = async (e) => {
    e.preventDefault();
    if (!replyText.trim()) return;
    setBusy(true);
    await onReply(replyText.trim());
    setReplyText('');
    setReplyOpen(false);
    setBusy(false);
  };

  return (
    <article className={`comment ${isTopLiked ? 'top-liked' : ''}`}>
      <header className="comment-head">
        <span className="comment-user">{safeText(comment.username)}</span>
        <span className="comment-date">{formatDate(comment.createdAt)}</span>
      </header>
      <div className="comment-content">{safeText(comment.content)}</div>
      <div className="comment-actions">
        <button
          className={`like-btn ${liked ? 'liked' : ''}`}
          onClick={onLike}
          disabled={liked}
          title={liked ? 'Already liked' : 'Like'}
        >
          {liked ? '♥' : '♡'} {comment.likes}
        </button>
        <button
          className="btn btn-sm"
          onClick={() => {
            if (!currentUser) { onRequireAuth(); return; }
            setReplyOpen(v => !v);
          }}
        >Reply</button>
        {canDelete && (
          <button className="btn btn-sm btn-danger" onClick={onDelete}>Delete</button>
        )}
      </div>

      {replyOpen && (
        <form className="reply-form" onSubmit={submitReply}>
          <textarea
            placeholder="Write a reply..."
            value={replyText}
            onChange={(e) => setReplyText(e.target.value)}
            maxLength={1000}
          />
          <div className="row" style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 6 }}>
            <button type="button" className="btn btn-sm" onClick={() => setReplyOpen(false)}>Cancel</button>
            <button type="submit" className="btn btn-sm btn-primary" disabled={busy || !replyText.trim()}>
              {busy ? '...' : 'Send'}
            </button>
          </div>
        </form>
      )}

      {comment.replies && comment.replies.length > 0 && (
        <div className="replies">
          {comment.replies.map((r) => {
            const canDelReply = currentUser && (
              currentUser.role === 'admin' || currentUser.id === String(r.user)
            );
            return (
              <div className="reply" key={r._id}>
                <div className="comment-head">
                  <span className="comment-user">{safeText(r.username)}</span>
                  <span className="comment-date">{formatDate(r.createdAt)}</span>
                </div>
                <div className="comment-content">{safeText(r.content)}</div>
                {canDelReply && (
                  <button
                    className="btn btn-sm btn-danger"
                    style={{ marginTop: 6 }}
                    onClick={() => onDeleteReply(r._id)}
                  >Delete</button>
                )}
              </div>
            );
          })}
        </div>
      )}
    </article>
  );
}
